import axios from 'axios';
import config from '../config';
import { showError } from '../utils';
import LogRocket from 'logrocket';
import { store } from '../store';
import { refreshAxiosInstance } from '../utils/axiosInstance';

export function login(
  phoneNumber,
  countryCode,
  encData,
  resend,
  platform,
  ssoInfo,
  storedUTMParams,
  emailCode = null,
  emailVerificationId = null,
  channel = null
) {
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        phone: phoneNumber,
        countryCode,
        platform: 'PHONEPE',
        emailCode,
      };
      if (resend) {
        body['resend'] = true;
      }
      return axios
        .post(`${config.apiBaseUrl}/new-auth/login-phone`, body)
        .then((resp) => {
          const responseBody = resp.data;
          if (responseBody.message === 'otpSent') {
            return responseBody;
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          showError(err);
          throw err;
        })
        .catch((err) => {
          showError(err);
          throw err;
        });
    })
    .catch((err) => {
      const body = channel
        ? {
            channel,
            resend,
            countryCode,
            phone: phoneNumber,
            platform: 'WEB',
          }
        : {
            phone: phoneNumber,
            countryCode,
            platform: platform || 'WEB',
            encData,
            ssoInfo,
            storedUTMParams,
            emailCode,
            evId: emailVerificationId,
            ...(resend && { resend: true }),
          };

      return axios
        .post(`${config.apiBaseUrl}/new-auth/login-phone`, body)
        .then((resp) => {
          const responseBody = resp.data;
          if (responseBody.message === 'otpSent') {
            return responseBody;
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          showError(err);
          throw err;
        })
        .catch((err) => {
          showError(err);
          throw err;
        });
    });
}

export function loginMagicLink(magicLink, platform) {
  const body = {
    installReferrer: magicLink,
    platform: platform || 'WEB',
  };
  return axios
    .post(`${config.apiBaseUrl}/new-auth/magic`, body)
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;
      if (responseBody.message === 'success') {
        console.log("@@@@@@", responseBody)
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function loginPhonepe(grantToken) {
  const body = {
    grantToken,
  };
  return axios
    .post(`${config.apiBaseUrl}/new-auth/phonepe/sso`, body)
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;
      if (responseBody.message === 'success') {
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      showError(err);
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifyOtp(
  phoneNumber,
  otp,
  platform,
  ssoInfo,
  emailCode = null
) {
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        phone: phoneNumber,
        otp,
        platform: 'PHONEPE',
        emailCode,
      };
      return axios
        .post(`${config.apiBaseUrl}/new-auth/otp`, body, {
          withCredentials: true,
        })
        .then((resp) => {
          console.log(resp, 'resp in verify otp 123');
          const responseBody = resp.data;
          const responseHeaders = resp.headers;

          if (responseBody.message === 'otpVerified') {
            // logEvent('Onboarding OTP Verified');
            return {
              headers: responseHeaders,
              body: responseBody,
              refreshToken: responseBody.refreshToken, // Get refresh token from response body
            };
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          throw err;
        });
    })
    .catch((err) => {
      if (err.message === 'Invalid response') {
        throw err;
      } else {
        const body = {
          phone: phoneNumber,
          otp,
          platform: platform || 'WEB',
          referrer: window.baseLandingUrl,
          ssoInfo,
          emailCode,
        };
        return axios
          .post(`${config.apiBaseUrl}/new-auth/otp`, body)
          .then((resp) => {
            console.log(resp, 'resp in verify otp 456');
            const responseBody = resp.data;
            const responseHeaders = resp.headers;
            if (responseBody.message === 'otpVerified') {
              return {
                headers: responseHeaders,
                body: responseBody,
              };
            }
            const err = new Error('Invalid response');
            err.data = responseBody;
            throw err;
          });
      }
    });
}

export function verifyEmailOTP(
  email,
  otp,
  platform,
  ssoInfo,
  emailCode = null
) {
  const token = store.getState().user.authToken;
  const otpVerifier = store.getState().app.emailOtpVerifier;
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      const body = {
        email,
        otp,
        platform: 'PHONEPE',
        otpVerifier,
        emailCode,
      };
      return axios
        .post(`${config.apiBaseUrl}/new-auth/verify-email-otp`, body, {
          headers: {
            Authorization: token,
          },
        })
        .then((resp) => {
          console.log(resp, 'resp in verify otp 123');
          const responseBody = resp.data;
          const responseHeaders = resp.headers;
          if (responseBody.message === 'success') {
            // logEvent('Onboarding OTP Verified');
            return {
              headers: responseHeaders,
              body: responseBody,
            };
          }
          const err = new Error('Invalid response');
          err.data = responseBody;
          throw err;
        });
    })
    .catch((err) => {
      if (err.message === 'Invalid response') {
        throw err;
      } else {
        const body = {
          email,
          otp,
          platform: platform || 'WEB',
          referrer: window.baseLandingUrl,
          otpVerifier,
        };
        return axios
          .post(`${config.apiBaseUrl}/new-auth/verify-email-otp`, body, {
            headers: {
              Authorization: token,
            },
          })
          .then((resp) => {
            console.log(resp, 'resp in verify otp 456');
            const responseBody = resp.data;
            const responseHeaders = resp.headers;
            if (responseBody.message === 'success') {
              return {
                headers: responseHeaders,
                body: responseBody,
              };
            }
            const err = new Error('Invalid response');
            err.data = responseBody;
            throw err;
          });
      }
    });
}

export function submitUserDetails(name, dob, gender, authToken) {
  const body = {
    name,
    dob,
    gender,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/register-details`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'userUpdated') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function userInfo(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/login-info?v=123`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200 || responseCode === 304) {
        /**
         * Identify user for Log Rocket sessions
         */
        if (responseBody?.userInfo?.userId) {
          // If user id found then identify user
          LogRocket.identify(responseBody.userInfo.userId, {
            name: responseBody.userInfo.userName,
            email: responseBody.userInfo.userEmail,
          });
        }
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function appConfig(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/config`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function verifyCorporate(email, authToken) {
  const body = {
    email,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/verify-b2b`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (
        responseBody.message === 'sponsorFound' ||
        responseBody.message === 'ssoAuthentication' ||
        responseBody.message === 'emailOTPVerification'
      ) {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}
export function sendEmailVerificationLink(email, resend = false) {
  const body = {
    email,
  };

  let url = `${config.apiBaseUrl}/new-auth/email-signup`;
  if (resend) {
    url = `${config.apiBaseUrl}/new-auth/resend-email-verification`;
  }
  return axios
    .post(url, body, {})
    .then((resp) => {
      let responseBody = resp.data;

      if (responseBody.message === 'success') {
        if (resp?.headers?.authorization) {
          responseBody = {
            ...responseBody,
            authorization: resp?.headers?.authorization,
          };
        }
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function confirmEmail(email, authToken) {
  const body = {
    email,
  };

  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/new-auth/confirm-add-email`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'emailAdded') {
        return responseBody;
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export function ssoLogin(encrypted, clientId, data, universalSsoExists) {
  let body = {
    encrypted,
    clientId,
  };

  if (data) {
    body = {
      data,
      clientId,
    };
  }

  return axios
    .post(
      universalSsoExists
        ? `${config.apiBaseUrl}/new-auth/universal-sso`
        : `${config.apiBaseUrl}/new-auth/visit-sso`,
      body,
      {
        withCredentials: true,
      }
    )
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return {
          headers: resp.headers,
          body: resp.data,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export function callMetaApi(authToken) {
  const headers = {
    authorization: authToken,
  };
  const params = {
    version: config.version,
  };
  return axios
    .get(`${config.apiBaseUrl}/users/meta`, {
      params,
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return {
          headers: resp.headers,
          body: resp.data,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      throw err;
    });
}

export const getPubnubToken = async (sourceId, action) => {
  try {
    const isChatOnly = store.getState().app.tatva || false;

    const headers = {
      authorization: store.getState().user.authToken,
    };
    const params = {
      sourceId,
      action,
    };

    const url = isChatOnly
      ? `${config.pbChatBaseUrl}/tele/pubnub/token`
      : `${config.apiBaseUrl}/pubnub/user/token`;

    const res = await axios.get(url, {
      params,
      headers,
    });
    const responseBody = res.data;
    if (responseBody.message === 'success') {
      return responseBody.data.userToken;
    }
    const err = new Error('Invalid response');
    err.data = responseBody;
    throw err;
  } catch (err) {
    showError('Error in fetching PubNub token', err);
  }
};

export const refreshAuthToken = (authToken) => {
  // Get the current (expired) auth token to send with refresh request
  const currentAuthToken = store.getState().user.authToken || authToken;

  // With HTTP-only cookies, we don't need to manually send the refresh token
  // The browser will automatically include it in the request
  // Use separate axios instance to avoid interceptor loops
  return refreshAxiosInstance
    .post(
      `/new-auth/user/refresh`,
      {},
      {
        headers: {
          // Send the current (expired) auth token for validation
          Authorization: currentAuthToken,
        },
        withCredentials: true, // This ensures cookies are sent
      }
    )
    .then((resp) => {
      const responseBody = resp.data;
      const responseHeaders = resp.headers;

      if (responseBody.message === 'success') {
        return {
          headers: responseHeaders,
          body: responseBody,
        };
      }

      const err = new Error('Refresh token expired or invalid');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      console.log('Refresh token failed:', err);
      throw err;
    });
};

export function authLogout(authToken) {
  const headers = {
    authorization: authToken,
  };

  return refreshAxiosInstance
    .post(
      `${config.apiBaseUrl}/new-auth/user/logout`,
      {},
      {
        headers,
      }
    )
    .then((resp) => {
      console.log('Logout', resp);
    })
    .catch((err) => {
      console.error('Error during logout:', err);
    });
}
